export default __webpack_public_path__ + "static/media/large_red_close.d48fbd2d.svg";